export const DAYS_COUNT = 5;

export enum ColumnNames {
  EXPORT = 'Export',
  TYPE = 'Type',
  GEO = 'Geo',
  DATE = 'Date',
  TIME = 'Time',
}

export const COLUMN_NAMES = {
  searchTypeName: {
    title: 'Search Type',
    dataIndex: 'searchTypeName',
    width: '',
  },
  name: { title: 'Title Number/Reference', dataIndex: 'name', width: '' },
  location: { title: 'Geo', dataIndex: 'location', width: '8rem' },
  date: { title: 'Date', dataIndex: 'date', width: '7rem' },
  time: { title: 'Time', dataIndex: 'time', width: '5rem' },
  status: { title: 'Status', dataIndex: 'status', width: '6rem' },
  fileFormat: { title: 'Action', dataIndex: 'fileFormat', width: '' },
};
